<template>
	<form @submit.prevent="submit" class="ps-form--profile-info">
		<loading :active="loading"
				 :can-cancel="false"
				 loader="dots"
				 color="#2292ef"
				 :is-full-page="true"></loading>
		<br>
		<div class="form-group">
			<label>{{word.first_name}}</label>
			<input class="form-control" type="text" placeholder="" v-model="first_name">
			<small v-if="errors && errors.first_name" class="text-danger">{{errors.first_name[0]}}</small>

		</div>
		<div class="form-group">
			<label>{{word.last_name}}</label>
			<input class="form-control" type="text" placeholder="" v-model="last_name">
			<small v-if="errors && errors.last_name" class="text-danger">{{errors.last_name[0]}}</small>
		</div>
		<div class="form-group">
			<label>{{word.phone_number}}</label>
			<input class="form-control" type="text" name="" placeholder="" v-model="phone_number">
			<small v-if="errors && errors.phone_number" class="text-danger">{{errors.phone_number[0]}}</small>
		</div>

		<div class="mt-2 mb-5">
			<label>{{word.location}}</label>
			<multiselect @search-change="getSuburbs" v-model="suburb_id" :options="suburbs"
						 placeholder="Location" label="name"
						 track-by="name">
				<template slot="singleLabel" slot-scope="props">
					<span class="mr-1" style="font-size: 11px;">{{props.option.country}}</span>
					<span class="mr-1" style="font-size: 11px;">{{props.option.state}}</span>
					<span class="mr-1" style="font-size: 11px;">{{props.option.city}}</span>
					<span class="mr-1">{{props.option.name}}</span>
					<span class="mr-1">{{props.option.post_code}}</span>
				</template>
				<template slot="option" slot-scope="props">
					<span class="mr-1" style="font-size: 11px;">{{props.option.country}}</span>
					<span class="mr-1" style="font-size: 11px;">{{props.option.state}}</span>
					<span class="mr-1" style="font-size: 11px;">{{props.option.city}}</span>
					<span class="mr-1">{{props.option.name}}</span>
					<span class="mr-1">{{props.option.post_code}}</span>
				</template>
			</multiselect>
			<!--<select class="search-element">-->
			<!--<option value=""> -&#45;&#45; </option>-->
			<!--<option value=""> -&#45;&#45; </option>-->
			<!--<option value=""> -&#45;&#45; </option>-->
			<!--</select>-->
		</div>
		<br>
		<figure>
			<p><strong>About me</strong></p>
			<div class="form-group">
				<textarea class="form-control" rows="6" v-model="professional_overview"></textarea>
			</div>
		</figure>
		<div class="form-group--submit text-center">
			<button type="submit" class="ps-btn ps-btn--sm ml-30">{{word.save}}</button>
		</div>
	</form>
</template>

<script>
	import Multiselect from 'vue-multiselect';
	import Loading from 'vue-loading-overlay';
	import 'vue-loading-overlay/dist/vue-loading.css';

	export default {
		components: {
			Multiselect, Loading
		},
		props: [

			'w',
			'user',
			'submit_url',
			'location'
		],
		data() {
			return {
				loading: false,
				url: null,
				errors: null,
				fields: null,
				word: {},
				User: {},
				last_name: null,
				first_name: null,
				phone_number: null,
				professional_overview: null,
				suburb_id: [],
				suburbs: []
			}
		},
		created() {

			this.url = this.submit_url;
			this.word = JSON.parse(this.w);
			this.User = JSON.parse(this.user);
			this.suburb_id = JSON.parse(this.location);
			this.last_name = this.User.last_name;
			this.first_name = this.User.first_name;
			this.phone_number = this.User.business_profile.business_phone_number;
			this.professional_overview = this.User.business_profile.about_me;
		},
		methods: {
			submit: function () {
				this.$Progress.start();
				this.loading = true;
				this.fields = {
					last_name: this.last_name,
					first_name: this.first_name,
					phone_number: this.phone_number,
					professional_overview: this.professional_overview,

				};
				if (this.suburb_id && this.suburb_id !== []) {
					this.fields.suburb_id = this.suburb_id.id;
				}
				let self = this;

				axios({
					method: "post",
					url: self.url + "?_method=post",
					data: self.fields
				})
					.then(function (response) {
						console.log(response.data);
						if (response.data.ok) {
							self.loading = false;
							self.$Progress.finish();
						} else {
							self.$Progress.fail();
						}
					})
					.catch(function (err) {
						console.log(err.response.data.errors);
						self.loading = false;
						self.$Progress.finish();
						self.errors = err.response.data.errors;
					});
			},
			getSuburbs: function (searchQuery, id) {
				if (searchQuery.length % 2 === 0) {
					this.$Progress.start();
					let self = this;


					axios({
						method: "get",
						url: "/suburb/search?_method=get&keyword=" + searchQuery
					})
						.then(function (response) {
							self.$Progress.finish();
							self.suburbs = response.data.suburbs;

						})
						.catch(function (err) {
							self.$Progress.fail();
							self.errors = err.response.data.errors;
						});
				}
			}

		}

	}
</script>
